let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bE6tX")).then(() => parcelRequire('cQFQ4'));